module.exports = __webpack_public_path__ + "static/media/sharing-overview-video.603ef6c2.mp4";